import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToast } from '@hooks/useToast';
import { getApiErrorMessage } from '@utils/apiError';

import { cancelCustomerDebts, executeScheduledPayment, updateCustomerPaymentMethod } from './api';

export function useCancelCustomerDebtsMutation() {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (customerId: string) => cancelCustomerDebts(customerId),
    onSuccess: () => {
      toast.success('Debt collection(s) canceled');
      queryClient.invalidateQueries({ queryKey: ['customers'] });
    },
    onError: () => {
      toast.error('Failed to cancel debt collection');
    },
  });
}

export function useExecuteScheduledPaymentMutation() {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: executeScheduledPayment,
    onSuccess: () => {
      toast.success('Payment sent for execution');
      // The detail panel's customer comes from either the list or the by-id query — refresh both.
      queryClient.invalidateQueries({ queryKey: ['customers'] });

      queryClient.invalidateQueries({ queryKey: ['customer'] });
    },
    onError: (error) => {
      toast.error(`Failed: ${getApiErrorMessage(error) ?? error.message}`);
    },
  });
}

export function useUpdateCustomerPaymentMethodMutation() {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: updateCustomerPaymentMethod,
    onSuccess: () => {
      toast.success('Payment method updated');
      // The detail panel's customer comes from either the list or the by-id query — refresh both.
      queryClient.invalidateQueries({ queryKey: ['customers'] });
      queryClient.invalidateQueries({ queryKey: ['customer'] });
    },
    onError: (error) => {
      toast.error(`Failed: ${getApiErrorMessage(error) ?? error.message}`);
    },
  });
}
